import { useQuery } from "@tanstack/react-query";
import { sessionsApi } from "@/lib/api/sessions";

export const activeSessionKeys = {
  all: ["active-session"] as const,
  byEpic: (epicId: string) => [...activeSessionKeys.all, epicId] as const,
};

/**
 * Lightweight hook to check if an epic has an active AI session.
 * Polls every 30s by default. Use this to conditionally enable
 * more frequent polling on other queries during active implementation.
 */
export function useActiveSession(epicId: string | undefined) {
  const { data, ...rest } = useQuery({
    queryKey: activeSessionKeys.byEpic(epicId ?? ""),
    queryFn: () => sessionsApi.getActive(epicId!),
    enabled: !!epicId,
    refetchInterval: 30_000,
    select: (res) => res.data,
  });

  return {
    session: data ?? null,
    hasActiveSession: !!data,
    ...rest,
  };
}
